import type { FC } from "react";

import { FieldInput } from "../form/field-input";
import { useEmailDraft } from "./email-draft-context";

export const EmailDraftSubject: FC = () => {
  const { handleUpdateSubject, setRecipientsOpen, isEditable } = useEmailDraft();

  return (
    <FieldInput
      name="subject"
      placeholder="Subject"
      onChange={(e) => handleUpdateSubject(e.target.value)}
      onFocus={() => setRecipientsOpen(false)}
      disabled={!isEditable}
      borderless
      inputProps={{ className: "text-foreground! opacity-100!" }}
    />
  );
};
